module.exports = __webpack_public_path__ + "static/media/pain-faces@2x.124ec60f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/pain-faces@2x.jpg
// module id = 906
// module chunks = 0